<template>
  <RollupChart :key="chart_key" class="relative w-full h-full" :chartid="chartid" :chartdata="chartdata" />
</template>

<script>
import RollupChart from "@/components/shared/RollupChart.vue"

export default {
  components: {
    RollupChart
  },
  props: {
    metricValues: {
      type: Array,
      default: () => []
    },
    chartid: {
      type: String,
      default: null
    },
    percentageChange: {
      type: Number,
      required: true
    },
    isDecreasePositive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      chartdata: this.createChartData(),
      chart_key: 1
    }
  },
  watch: {
    metricValues: "updateChartData",
    percentageChange: "updateChartData"
  },
  methods: {
    createChartData() {
      return [
        {
          backgroundColor: ["#27C884"],
          data: this.metricValues.length ? this.metricValues.map((x) => x.value) : [],
          datalabels: { color: "#000" },
          labels: this.metricValues.length ? this.metricValues.map((x) => this.$moment(new Date(x.datetime)).format("MMM Do, YY")) : []
        }
      ]
    },
    updateChartData() {
      setTimeout(() => {
        this.chartdata = this.createChartData()
        this.generateColors()
      }, 800)
    },
    generateColors() {
      this.chart_key += 1
      const is_negative = Math.sign(this.percentageChange)
      const green_border = "#27C884"
      const red_border = "#F05B5B"
      const yellow_border = "#FFBE15"

      if (is_negative === -1) {
        this.chartdata[0].backgroundColor = [this.isDecreasePositive ? green_border : red_border]
      } else if (is_negative === 1) {
        this.chartdata[0].backgroundColor = [this.isDecreasePositive ? red_border : green_border]
      } else {
        this.chartdata[0].backgroundColor = [yellow_border]
      }
    }
  }
}
</script>
